exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".third-frame-style .el-dialog__body .avatar-upload{width:120px!important}", ""]);

// exports
